import { defineMessages } from 'react-intl';

export const lastSourceRequiredMessages = defineMessages({
  tooltip: {
    id: 'chat.sourceControl.atLeastOneSourceRequired',
    defaultMessage: 'At least one evidence source is required',
    description: 'Tooltip when the last Evidence chat source cannot be disabled',
  },
});
